import React from 'react';
import MoreActions from '../../MoreActions/MoreActions';
import * as S from './CellFormatter.styles';

export const MoreActionsFormatter = ({ cell, formatExtraData }) => {
  const formaterItems = formatExtraData?.items?.map((item) => {
    return {
      ...item,
      action: () => item?.action(cell?.extraData),
    };
  });

  return cell ? (
    <S.Cell align={cell.align}>
      <MoreActions
        items={cell.items || formaterItems}
        position={formatExtraData.position}
      />
    </S.Cell>
  ) : null;
};
